import React, {Component} from "react"
import PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import {Body, H1} from "@irati/ui/src/Typography"
import Loading from "@irati/ui/src/Loading"
import productSettingsService from "@irati/permissions/services/productSettings"
import authentication from "@irati/auth"

import {
  Business,
  ProductSettingsRecognition,
  ProductSettingsRecognitionValuesByVisibility,
  ProductSettingsRecognitionValuesByRank
} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import {RewardPermission, RewardVisibility, SharingPermissions, PollCreation} from "./index"

export const ADMIN_ONLY = "ADMIN_ONLY"
export const ADMIN_AND_MANAGER = "ADMIN_AND_MANAGER"
export const EVERYONE = "EVERYONE"
export const OFF = "OFF"
export const ON = "ON"
export const LIMITED = "LIMITED"

const pollCreationOptions = [
  {value: ProductSettingsRecognitionValuesByRank.TeamLeaderOnly, label: "admin.permissions.poll.adminOnly"},
  {value: ProductSettingsRecognitionValuesByRank.TeamLeaderAndManager, label: "admin.permissions.poll.adminAndManager"},
  {value: ProductSettingsRecognitionValuesByRank.Everyone, label: "admin.permissions.poll.everyone"}
]

const recognitionSharingOptions = [
  ...pollCreationOptions,
  {value: ProductSettingsRecognitionValuesByRank.Off, label: "admin.permissions.recognition.off"}
]

const rewardVisibilityOptions = [
  {value: ProductSettingsRecognitionValuesByVisibility.Visible, label: "admin.permissions.reward.on"},
  {value: ProductSettingsRecognitionValuesByVisibility.Limited, label: "admin.permissions.reward.limited"},
  {value: ProductSettingsRecognitionValuesByVisibility.Hidden, label: "admin.permissions.reward.off"}
]

interface Props {}

interface State {
  sharing?: ProductSettingsRecognition["sharing"],
  createPoll?: ProductSettingsRecognition["createPoll"],
  viewReward?: ProductSettingsRecognition["viewReward"],
  attachReward?: ProductSettingsRecognition["attachReward"],
  load: Promise<any>
}

class RecognitionSettings extends Component<Props> {
  static propTypes = {
    auth: PropTypes.object.isRequired
  }

  state: State = {
    load: hangPromise()
  }

  componentDidMount() {
    this.setState({load: this.getRecognitionPermissions(authentication.business())})
  }

  getRecognitionPermissions = async(business: Business) => {
    const ps = await productSettingsService.get(business.uuid, business.rootTeamId)

    const {sharing, createPoll, viewReward, attachReward} = ps.recognitionSettings || {}
    this.setState({
      sharing,
      createPoll,
      viewReward,
      attachReward
    })
  }

  render() {
    const {sharing, createPoll, viewReward, attachReward, load} = this.state

    const isRewardDisabled = authentication.apps("recognition.recognition.isRewardDisabled")
    const isRecognitionEnabled = authentication.apps("recognition")

    return (
      <>
        <H1 marginBottom={1}>Recognition</H1>
        {!isRecognitionEnabled ? (
          <>
            <Body marginBottom={0.5}>
              <FormattedMessage id="admin.permissions.recognition.paragraph1" />
            </Body>
            <Body marginBottom={5}>
              <FormattedMessage id="admin.permissions.recognition.paragraph2" />
            </Body>
          </>
        ) : (
          <>
            <Loading load={load}>
              <SharingPermissions options={recognitionSharingOptions} value={sharing} />
              <PollCreation options={pollCreationOptions} value={createPoll} />
              {!isRewardDisabled && (
                <>
                  <RewardVisibility options={rewardVisibilityOptions} value={viewReward} />
                  <RewardPermission options={recognitionSharingOptions} value={attachReward} />
                </>
              )}
            </Loading>
          </>
        )}
      </>
    )
  }
}

export default RecognitionSettings
